import posthog from 'posthog-js'
import { Environment } from '@carsys/enums/environment'
import { IPreflight } from '@cbgms/api/modules/root'

const POSTHOG_API_KEY = 'phc_sgRAzFpn9wvc73urhXvF5EJGofxodp9uDHEcmhzAaSgr'
const POSTHOG_HOST = 'https://eu.i.posthog.com'

/**
 * Determines whether PostHog should be enabled.
 * Only enabled on dev environment — via the preflight Environment field
 * or by checking if the hostname starts with "develop".
 */
export function isPostHogEnabled(preflight: IPreflight): boolean {
  if ([Environment.Develop, Environment.Localhost].includes(preflight.Environment)) {
    return true
  }

  // Fallback: check hostname
  if (typeof window !== 'undefined' && window.location.hostname.startsWith('develop')) {
    return true
  }

  return false
}

/**
 * Initialise PostHog.
 * Should only be called once and only in the develop environment.
 */
export function initPostHog(preflight: IPreflight): typeof posthog | null {
  if (!isPostHogEnabled(preflight)) {
    return null
  }

  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    loaded: _ph => {
      // Optionally log to confirm PostHog loaded in dev
      console.info('[PostHog] Initialized in develop environment')
    }
  })

  return posthog
}

export default posthog
